var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "identity-awaiting"
  }, [_c('substrate-mount', [_c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.$t('we.need.a.little.processing.time'))
    }
  })])], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }